// types
import { ZoomStateSchema } from "../types/zoomTypes";

export const getZoomState = (state: ZoomStateSchema) => state.zoom;
